<template>
  <v-row align="center">
    <v-col cols="auto" sm="9" md="8">
      <span class="header-title">
        <slot name="title">Default Title</slot>
      </span>
      <span class="body-2">
        <slot name="subtitle"></slot>
      </span>
    </v-col>
    <v-col cols="12" sm="3" md="4" order="first" order-sm="2">
      <v-row dense>
        <v-col cols="12" class="text-right">
          <v-btn
            v-if="backButton"
            color="#29284c"
            small
            outlined
            width="120"
            class="text-capitalize ml-auto mt-2"
            @click="backAction"
            >Previous Step</v-btn
          >
          <v-btn
            v-if="button"
            color="#FF347C"
            small
            depressed
            :disabled="disabled"
            width="120"
            class="white--text text-capitalize ml-2 mt-2"
            @click="buttonAction"
          >
            <slot name="buttonText">Next Step >></slot>
          </v-btn>
          <slot name="extraButton" />
        </v-col>
      </v-row>
    </v-col>
    <v-row align="end" v-if="numbers" justify="end" class="pr-5">
      <span class="display-4 font-weight-semibold" style="color: #ff347c; letter-spacing: -0.3rem">
        <slot name="current-step">1</slot>
      </span>
      <span class="display-4 custom-text stick">/</span>
      <span class="display-1 custom-text" style="margin-bottom: 7px">
        <slot name="max-step">2</slot>
      </span>
    </v-row>
  </v-row>
</template>
<script>
export default {
  props: {
    buttonAction: {
      required: false,
      type: Function,
      default: () => {},
    },
    backAction: {
      required: false,
      type: Function,
      default: () => {},
    },
    inside: {
      required: false,
      default: false,
      type: Boolean,
    },
    button: {
      required: false,
      type: Boolean,
      default: () => true,
    },
    numbers: {
      required: false,
      type: Boolean,
      default: () => false,
    },
    disabled: {
      required: false,
      type: Boolean,
      default: () => false,
    },
    backButton: {
      required: false,
      type: Boolean,
      default: false,
    },
  },
};
</script>
<style scoped>
span {
  display: block;
}
.outside {
  margin-right: -80px !important;
}
.header-title {
  font-size: 28px;
  font-weight: 500;
}
.stick {
  letter-spacing: -0.5rem !important;
}
</style>
